import { Button, Dialog, DialogContent, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";

interface ChatbotTestDialogProps {
  open: boolean;
  onClose: () => void;
  // Instagram-аккаунт, к которому подключён чат-бот (без @)
  username?: string | null;
  // Кодовые слова; пусто — бот срабатывает на любое сообщение
  keywords?: string[];
  direct?: boolean;
  comment?: boolean;
}

/**
 * «Как протестировать чат-бота?» — показываем после создания чат-бота на кодовое слово
 * и из шага «Протестируйте чат-бота» в «Быстром старте».
 */
export const ChatbotTestDialog = ({ open, onClose, username, keywords = [], direct = true, comment = false }: ChatbotTestDialogProps) => {
  const account = username ? `«@${username}»` : "Instagram";
  const words = keywords.filter(Boolean);
  const what = words.length > 0 ? <>кодовое слово <b>«{words[0]}»</b></> : <>любое сообщение</>;

  const steps = [
    <>Ещё раз проверьте настройки чат-бота в аккаунте {account}.</>,
    <>Войдите в <b>другой</b> аккаунт Instagram — бот не отвечает сообщениям от самого себя.</>,
    direct && <>Напишите {what} в Директ {account}. Бот ответит через несколько секунд.</>,
    comment && <>Или оставьте комментарий с {words.length > 0 ? <>кодовым словом <b>«{words[0]}»</b></> : "любым текстом"} под постом {account} — бот пришлёт ответ в Директ.</>,
  ].filter(Boolean);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "24px" } }}>
      <DialogContent sx={{ p: 4 }}>
        <div className="flex items-start justify-between gap-2 mb-4">
          <div className="text-2xl font-bold">Как протестировать чат-бота?</div>
          <IconButton size="small" onClick={onClose} aria-label="Закрыть">
            <MdClose />
          </IconButton>
        </div>
        <ol className="flex flex-col gap-4 mb-6">
          {steps.map((step, index) => (
            <li key={index} className="flex items-start gap-3">
              <span className="shrink-0 w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center font-medium">
                {index + 1}
              </span>
              <span className="pt-1">{step}</span>
            </li>
          ))}
        </ol>
        <Button fullWidth variant="contained" size="large" onClick={onClose} sx={{ borderRadius: "12px", py: 1.5 }}>
          Понятно
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ChatbotTestDialog;
